import React from 'react';
import Container from '../Container';
import { Desktop, Tablet } from '../../constants/responsive';
import { css } from '@emotion/core';
import { FormattedHTMLMessage, useIntl } from 'gatsby-plugin-intl';
import { useAppContext } from '../../context/AppContext';
import { graphql, useStaticQuery } from 'gatsby';
import { Helmet } from 'react-helmet';
import ReqDemoBtn from '../ReqDemo';
const Button = ({ children, ...rest }) => {
  // 底部【联系我们】的组件实例对象
  const { institutionsFormRef } = useAppContext();
  return (
    <div
      css={css`
        width: auto;
        padding: 0 20px;
        height: 47px;
        border-radius: 41px;
        background-color: #ffffff;
        cursor: pointer;

        text-align: center;
        font-size: 16px;
        font-weight: bold;
        line-height: 47px;
        color: #004e8f;
      `}
      {...rest}
      onClick={() => {
        window.scrollTo({
          top: institutionsFormRef.current.offsetTop,
          behavior: 'smooth',
        });
      }}
    >
      {children}
    </div>
  );
};

const InstitutionsBanner = ({ section = 'advisory', ...marginTopCss }) => {
  const intl = useIntl();
  const data = useStaticQuery(graphql`
    query {
      advisory: file(relativePath: { eq: "institutions/advisory-frame.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      smartfund: file(
        relativePath: { eq: "institutions/smartfund-frame.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      fundsuper: file(relativePath: { eq: "institutions/fund-super.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      advisoryPhone: file(
        relativePath: { eq: "institutions/advisory-frame-phone.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      smartfundPhone: file(
        relativePath: { eq: "institutions/smartfund-frame-phone.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      fundsuperPhone: file(
        relativePath: { eq: "institutions/fund-super-phone.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      advisoryIpad: file(
        relativePath: { eq: "institutions/advisory-frame-ipad.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      smartfundIpad: file(
        relativePath: { eq: "institutions/smartfund-frame-ipad.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      fundsuperIpad: file(
        relativePath: { eq: "institutions/fund-super-ipad.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      poster: file(relativePath: { eq: "institutions/test-poster.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);
  return (
    <>
      <div
        css={css`
          background: url('/institutions/institution-bg.png') center no-repeat;
          background-size: 100% 100%;
          width: 100%;
          display: flex;
          overflow: hidden;
          justify-content: center;
          position: relative;
          color: #333333;
          ${Tablet} {
            padding-top: 0px;
            height: 458px;
          }
          ${Desktop} {
            padding-top: 20px;
            height: 615px;
          }
        `}
      >
        <Container
          css={css`
            z-index: 1;
            position: relative;
          `}
        >
          {/* 字 */}
          <div
            css={css`
              color: #333333;
              margin-top: 62px;
              display: flex;
              flex-direction: column;
              align-items: center;
              ${Tablet} {
                margin-top: 114px;
                display: block;
              }
              ${Desktop} {
                margin-top: 171px;
                display: block;
              }
            `}
          >
            <p
              css={css`
                margin-bottom: ${{
                  advisory: '26px',
                  fundsuper: '20px',
                  smartfund: '20px',
                }[section]};
                width: ${{
                  advisory: '203px',
                  fundsuper: 'auto',
                  smartfund: 'auto',
                }[section]};
                font-size: 32px;
                line-height: 44px;
                font-weight: 700;
                color: #333333;
                text-align: center;
                ${Tablet} {
                  font-size: 36px;
                  line-height: 48px;
                  text-align: left;
                  color: #595959;
                  width: ${{
                    advisory: `${intl.locale === 'en' ? '263px' : 'auto'}`,
                    fundsuper: 'auto',
                    smartfund: 'auto',
                  }[section]};
                }
                ${Desktop} {
                  font-size: 48px;
                  line-height: 52px;
                  text-align: left;
                  width: ${{
                    advisory: 'auto',
                    fundsuper: 'auto',
                    smartfund: 'auto',
                  }[section]};
                }
              `}
            >
              <FormattedHTMLMessage id={`institutions.${section}.title`} />
            </p>
            <p
              css={css`
                color: #333333;
                text-align: center;
                font-size: 18px;
                width: 270px;
                ${Tablet} {
                  width: 339px;
                  margin-bottom: 37px;
                  font-weight: 400;
                  font-size: 18px;
                  color: #595959;
                  line-height: 24px;
                  text-align: left;
                }
                ${Desktop} {
                  width: 580px;
                  margin-bottom: 37px;
                  font-weight: 400;
                  font-size: 24px;
                  line-height: 33px;
                  text-align: left;
                }
              `}
            >
              <FormattedHTMLMessage id={`institutions.${section}.text`} />
            </p>
            {/* 【按钮】 */}
            <div
              css={css`
                width: 166px;
                margin-top: ${{
                  advisory: '19px',
                  fundsuper: '77px',
                  smartfund: '53px',
                }[section]};
                margin-bottom: 49px;
                ${Tablet} {
                  width: 180px;
                }
                ${Desktop} {
                  width: 204px;
                  margin-top: 0px;
                  margin-bottom: 0px;
                }
              `}
            >
              <ReqDemoBtn height={42} />
            </div>
          </div>
          {/* 视频动画 */}
          <div
            css={
              {
                advisory: css`
                  width: 272px;
                  margin: 0 auto;

                  position: relative;
                  ${Tablet} {
                    // width: 272px;
                    // right: -30px;
                    // position: relative;
                    margin-left: 0;
                    width: 379px;
                    height: 458px;
                    position: absolute;
                    right: 0px;
                    top: 0px;
                  }
                  ${Desktop} {
                    width: 663px;
                    height: 608px;
                    position: absolute;
                    right: -178px;
                    top: 0px;
                  }
                `,
                fundsuper: css`
                  width: 272px;
                  margin: 0 auto;
                  position: relative;
                  ${Tablet} {
                    margin-left: 0;
                    width: 379px;
                    height: 458px;
                    position: absolute;
                    right: 0px;
                    top: 0px;
                  }
                  ${Desktop} {
                    width: 714px;
                    height: 608px;
                    position: absolute;
                    right: -178px;
                    top: 0px;
                  }
                `,
                smartfund: css`
                  width: 272px;
                  margin: 0 auto;

                  position: relative;
                  ${Tablet} {
                    margin-left: 0;
                    width: 379px;
                    height: 458px;
                    position: absolute;
                    right: 0px;
                    top: 0px;
                  }
                  ${Desktop} {
                    margin-left: 0;
                    width: 710px;
                    height: 608px;
                    position: absolute;
                    right: -178px;
                    top: 0px;
                  }
                `,
              }[section]
            }
          >
            <img
              css={css`
                width: 100%;
                height: 100%;
                display: none;
                // ${Tablet} {
                //   display: block;
                // }
                ${Desktop} {
                  display: block;
                }

              `}
              src={data[section].childImageSharp.fluid.src}
              alt=''
            />
            <img
              css={css`
                width: 100%;
                height: 100%;
                display: none;
                ${Tablet} {
                  display: block;
                }
                ${Desktop} {
                  display: none;
                }
              `}
              src={data[`${section}Ipad`].childImageSharp.fluid.src}
              alt=''
            />
            <img
              css={css`
                width: 100%;
                height: 100%;
                display: block;
                ${Tablet} {
                  display: none;
                }
                ${Desktop} {
                  display: none;
                }
              `}
              src={data[`${section}Phone`].childImageSharp.fluid.src}
              alt=''
            />
            {/*    <video
                  className={`${section}-banner-video`}
                  css={
                    {
                      advisory: css`
                        position: absolute;
                        height: 92%;
                        top: 3%;
                        left: 6%;
                        // z-index: 5;
                        border-radius: 20px;
                        width: 84%;
                      `,
                      fundsuper: css`
                        position: absolute;
                        top: 7%;
                        // top: -1%;
                        left: 6%;
                        // z-index: 5;
                        height: 84%;
                        width: 88%;
                        border-radius: 20px;
                      `,
                      smartfund: css`
                        position: absolute;
                        top: 10.5%;
                        left: 7%;
                        // z-index: 5;
                        border-radius: 10px;
                        height: 74%;
                        width: 84%;
                      `,
                    }[section]
                  }
                  src={`/institutions/video/${section}-${intl.locale}.mp4`}
                  poster={`/institutions/poster/${section}-${intl.locale}.png`}
                  autoPlay
                  // controls
                  muted
                  loop
                  x5-playsinline='true'
                  playsinline='true'
                  webkit-playsinline='true'
                  preload='preload'
                  x5-video-player-type='h5'
                >
                  <source src='' type='video/mp4' />
                  <source src='' type='video/mov' />
                  您的浏览器不支持Video标签。
                </video> */}
          </div>
        </Container>
      </div>
    </>
  );
};

export default InstitutionsBanner;
